<template>
  <div class="container">
    <HMModalHeader :title="formTitle" @close="$emit('close')" />
    <div>
      <div ref="wrapper" class="row w-100 pt-3">
        <div class="col-12">
          <HMTextInput
            type="text"
            :label="$t('PODCASTS.LABELS.EPISODE_TITLE')"
            v-model="episode.title"
            :name="episode.title"
            rules="required"
          />
        </div>
        <div class="col-12">
          <HMVueEditor
            id="hm-vue-email-editor"
            class="w-100"
            v-model="episode.notes"
            :placeholder="$t('PODCASTS.LABELS.EPISODE_SHOW_NOTES')"
            :customToolbar="podcastDescriptionToolbar"
            :pasteImageDisabled="true"
          />
        </div>
        <div v-if="!episode.media" class="col-12 mt-3">
          <HMButton color="primary" @click="showAddMediaForm">
            <font-awesome-icon :icon="['far', 'file-upload']" />
            <span class="text-nowrap ml-2">
              {{ $t('PODCASTS.BUTTONS.ADD_CONTENT') }}
            </span>
          </HMButton>
        </div>
        <div
          v-else
          class="col d-flex flex-row align-items-center flex-nowrap w-100 mt-3"
        >
          <HMFilePreview :file="episode.media.media" class="flex-grow-1 mr-4" />
          <HMButton color="outline-gray" @click="removeMedia">
            <font-awesome-icon :icon="['far', 'trash']" />
            <span class="text-nowrap ml-2">
              {{ $t('GENERAL.BUTTON.REMOVE') }}
            </span>
          </HMButton>
        </div>
        <div class="col-12 mt-4">
          <HMCheckBox v-model="episode.explicit">
            {{ $t('PODCASTS.LABELS.EPISODE_CONTAINS_EXPLICIT_CONTENT') }}
          </HMCheckBox>
        </div>
      </div>
    </div>
    <form @submit.prevent="onConfirm()" class="mt-4">
      <HMModalFooter
        :submitButton="submitButtonLabel"
        :disabled="missingData"
        :discardButton="$t('GENERAL.BUTTON.CANCEL')"
        @close="$emit('close')"
      />
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import MediaFormModal from '@/web/components/media-library/MediaFormModal';
import LibraryAddMedia from '@/web/views/admin/media-library/LibraryAddMedia';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';
import HMCheckBox from '@/web/components/common/HMCheckBox';
import HMVueEditor from '../common/HMVueEditor';

export default {
  name: 'PodcastEpisodeModal',
  components: { HMCheckBox, HMVueEditor },
  mixins: [TeacherPermissionsMixin],
  computed: {
    podcastDescriptionToolbar() {
      return [
        ['bold', 'italic'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
      ];
    },
    formTitle() {
      if (this.episode.id) {
        return this.$t('PODCASTS.TITLES.EDIT_EPISODE');
      } else {
        return this.$t('PODCASTS.TITLES.ADD_EPISODE');
      }
    },
    submitButtonLabel() {
      if (this.episode.id) {
        return this.$t('PODCASTS.BUTTONS.SAVE_EPISODE');
      } else {
        return this.$t('PODCASTS.BUTTONS.ADD_NEW_EPISODE');
      }
    },
    missingData() {
      if (!this.episode.media) return true;
      if (!this.episode.title) return true;

      return false;
    },
  },
  props: {
    episode: {
      type: Object,
    },
    confirm: null,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async showAddMediaForm() {
      this.$modal.show(
        MediaFormModal,
        {
          showSelectMedia: true,
          multiSelect: false,
          showEditMedia: false,
          videoUploadAllowed: this.videoUploadAllowed,
          allowedTypes: ['audio', 'video'],
          selectedType: 'audio',
          showEmbedMedia: false,
          showEmbedHtml: false,
        },
        { classes: ['vm--inline-modal'], clickToClose: false },
        {
          'media-selected': async content => {
            console.log('selected media', content);
            Vue.set(this.episode, 'media', content[0]);
          },
          'media-added': media => {
            this.showEditMedia(media);
          },
        }
      );
    },
    showEditMedia(media) {
      this.$modal.show(
        LibraryAddMedia,
        {
          medaiData: media,
          showAsModal: true,
        },
        { classes: ['vm--inline-modal'] },
        {
          'media-saved': async media => {
            console.log('media saved', media);
            Vue.set(this.episode, 'media', media);
          },
        }
      );
    },
    async onConfirm() {
      await this.$emit('close');
      await this.confirm(this.episode);
    },
    async onDiscard() {
      if (this.discard) {
        await this.discard();
      }
      await this.$emit('close');
    },
    removeMedia() {
      this.episode.media = null;
    },
  },
  async mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
